import { HttpRequestMethodEnum } from "@/types/api";
import { request } from "../api";
import { config } from "@/config";

export const checkUserBlockingAsync = async (
  accessToken: string,
  partnerId: number,
) => {
  try {
    const query = await request(
      config.api.maitrejaApi.endpoints.checkUserBlocking,
      HttpRequestMethodEnum.POST,
      { id: partnerId },
      accessToken,
    );

    return query.message;
  } catch (err) {
    // @ts-expect-error
    console.log(err.message);
  }
};
